export const invFields = {
  fieldDef: {
    steps: [
      {
        fields: [
          /*{
            key: 'orgId',
            type: 'edit_text',
            label: 'OrgId',
            hint: 'Provide orgId',
            v_required: { value: true, err: 'Provide orgId' },
            v_min: { value: 2, err: 'orgId is too short (2 - 10)' },
            v_max: { value: 10, err: 'orgId is too long (2 - 10)' },
            placement: 'left'
          },*/
          {
            key: 'title',
            type: 'edit_text',
            label: 'Product name',
            hint: 'Provide Product name',
            v_required: { value: true, err: 'Provide Product name' },
            v_min: { value: 2, err: 'Product name is too short (2 - 200)' },
            v_max: { value: 200, err: 'Product name is too long (2 - 200)' },
            placement: 'left'
          },
          {
            key: 'prodId', // Connects to Master
            type: 'edit_text',
            label: 'Prod Id',
            hint: 'Select Prod Id',
            v_required: { value: false, err: 'Select Prod Id' },
            v_min: { value: 2, err: 'Prod Id is too short (2 - 200)' },
            v_max: { value: 200, err: 'Prod Id is too long (2 - 200)' },
            placement: 'right'
          },
          {
            key: 'brand',
            type: 'edit_text',
            label: 'Brand',
            hint: 'Provide Brand',
            v_required: { value: true, err: 'Provide brand' },
            v_min: { value: 2, err: 'Brand is too short (2 - 200)' },
            v_max: { value: 200, err: 'Brand is too long (2 - 200)' },
            placement: 'left'
          },
          {
            key: 'brandId', // Connects to Master
            type: 'edit_text',
            label: 'Brand Id',
            hint: 'Select Brand Id',
            v_required: { value: false, err: 'Select Brand Id' },
            v_min: { value: 2, err: 'Brand Id is too short (2 - 200)' },
            v_max: { value: 200, err: 'Brand Id is too long (2 - 200)' },
            placement: 'right'
          },
          {
            key: 'itype',
            type: 'radio',
            label: 'Type',
            hint: 'Select Type',
            options: [
              { key: 'CONSUMABLE', label: 'CONSUMABLE', value: false },
              { key: 'EQUIPMENT', label: 'EQUIPMENT', value: false },
            ],
            v_required: { value: true, err: 'Select Type' },
            placement: 'left'
          },
          {
            key: 'quantity',
            type: 'edit_text',
            label: 'Quantity',
            hint: 'Provide Quantity',
            v_required: { value: false, err: 'Provide Quantity' },
            v_int: { value: true, err: 'Provide Quantity' },
            v_min: { value: 0, err: 'Quantity is too less (0 to 1000000000)' },
            v_max: { value: 1000000000, err: 'Quantity is too high (0 to 1000000000)' },
            placement: 'right'
          },
          {
            key: 'purchaseDate',
            type: 'date',
            label: 'Purchase Date',
            hint: 'Purchase Date',
            v_required: { value: true, err: 'Provide Purchase Date' },
            v_date: { value: true, err: 'Provide a valid Purchase Date' },
            placement: 'left'
          },
          {
            key: 'expiryDate',
            type: 'date',
            label: 'Expiry Date',
            hint: 'Expiry Date',
            v_required: { value: false, err: 'Provide Expiry Date' },
            v_date: { value: true, err: 'Provide a valid Expiry Date' },
            placement: 'right'
          },
          {
            key: 'invoiceDate',
            type: 'date',
            label: 'Invoice Date',
            hint: 'Invoice Date',
            v_required: { value: true, err: 'Provide Invoice Date' },
            v_date: { value: true, err: 'Provide a valid Invoice Date' },
            placement: 'left'
          },
          {
            key: 'maintenanceDate',
            type: 'date',
            label: 'Next Maintenance Date',
            hint: 'Next Maintenance Date',
            v_required: { value: false, err: 'Provide Next Maintenance Date' },
            v_date: { value: true, err: 'Provide a valid Next Maintenance Date' },
            placement: 'right'
          },
          {
            key: 'warrantyStartDate',
            type: 'date',
            label: 'Warranty Start Date',
            hint: 'Warranty Start Date',
            v_required: { value: false, err: 'Provide Warranty Start Date' },
            v_date: { value: true, err: 'Provide a valid Warranty Start Date' },
            placement: 'left'
          },
          {
            key: 'warrantyDate',
            type: 'date',
            label: 'Warranty End Date',
            hint: 'Warranty End Date',
            v_required: { value: false, err: 'Provide Warranty End Date' },
            v_date: { value: true, err: 'Provide a valid Warranty End Date' },
            placement: 'right'
          },
          {
            key: 'vendorName',
            type: 'edit_text',
            label: 'Vendor Name',
            hint: 'Provide Vendor Name',
            v_required: { value: false, err: 'Provide Vendor Name' },
            v_min: { value: 2, err: 'Vendor Name is too short (2 - 200)' },
            v_max: { value: 200, err: 'Vendor Name is too long (2 - 200)' },
            placement: 'left'
          },
          {
            key: 'vendorPhone',
            type: 'edit_text',
            label: 'Vendor Phone',
            hint: 'Provide Vendor Phone',
            v_required: { value: false, err: 'Provide Vendor Phone' },
            v_phone: { value: true, err: 'Provide a Vendor phone number' },
            placement: 'right'
          }
        ]
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/Data/FormFields.js